import {Col} from "react-bootstrap";
import ApproveButton from "./ToolBarButtons/ApproveButton";
import RejectButton from "./ToolBarButtons/RejectButton";
import refreshlogo from "../../assets/image/refresh.svg";
import React, {useContext} from "react";
import DeleteButton from "./ToolBarButtons/DeleteButton";
import {ActionPanelContext} from "../../context/action";

export default function AdminMobileToolbar(props) {
    let {
        onApproveButtonClick,
        onRejectButtonClick,
        onDeleteButtonClick,
        refreshCriteria,
        toolBarColStyle
    } = props;

    const {handleRefresh} = useContext(ActionPanelContext);

    const onRefreshClicked = () => {
        const onSuccess = () => {
        }
        const onError = () => {
        }

        handleRefresh(refreshCriteria, onSuccess, onError);
    }

    return (
        (
            <>
                <Col style={toolBarColStyle} className="text-nowrap d-sm-block">
                    <ApproveButton onApproveButtonClick={onApproveButtonClick}/>
                </Col>
                <Col style={toolBarColStyle} className="text-nowrap d-sm-block">
                    <RejectButton onRejectButtonClick={onRejectButtonClick}/>
                </Col>
                {onDeleteButtonClick &&
                    (<Col style={toolBarColStyle} className="text-nowrap d-sm-block">
                        <DeleteButton onDeleteButtonClick={onDeleteButtonClick} buttonTitle="Delete" mobileToolBar/>
                    </Col>)
                }
                <Col style={{padding: 0, paddingLeft: 5, paddingRight: 10, textAlign: "center", alignSelf: "center"}}
                     className={'d-sm-block'}>
                    <button style={{border: 'none', background: "none"}} onClick={onRefreshClicked}
                    >
                        <img
                            src={refreshlogo}
                            height="25"
                            className="d-inline-block"
                            alt="React Bootstrap logo"
                        />
                    </button>
                </Col>
            </>)
    );
}